export const mergeClassNames = (classNames: string[]) => {
  return classNames.filter((className) => className).flatMap((className) => className.split(' '));
};
